module.exports = __webpack_public_path__ + "img/ModifyPrice.d24e4849.png";